<footer class="footer">

    <div class="footer-wrap">

        <div class="w-100 clearfix">

          <span class="d-block text-center text-sm-left d-sm-inline-block">© 2021 <a href="http://www.ytygroup.com/" target="_blank">YTY Group</a>. All Rights Reserved.</span>

        </div>

    </div>

  </footer>